import React, { Component } from "react";
import "./App.css";
import Penhora from "./penhora";
import Router from "./config/router";
import Menu from "./layout/navbar";
import Footer from "./components/footer/footer";

class App extends Component {
  state = {};

  render() {
    return (
      <div className="App main-wrapper">
        <Menu />
        <Router />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js